module.exports = __webpack_public_path__ + "static/img/长图设计-3D长图.2eeb70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/长图设计-3D长图.png
// module id = AgCg
// module chunks = 1